import styled from 'styled-components';

export const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 5%;
  text-align: left;
`;

export const H1 = styled.div`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1rem;
`;
